export const API_CONFIG = {
  BASE_URL: 'https://api.vps-kurznews.eu',//'http://0.0.0.0:8080',//
  ENDPOINTS: {
    LOGIN: '/login',
    NEWS: {
      BASE: '/admin/news',
      MANUAL: '/admin/news/manual',
      IMPORT_BY_LINK: '/admin/news/import/by-link',
      EDIT: (id: string) => `/admin/news/${id}/edit`,
      TOGGLE: (id: string, type: string) => `/admin/news/${id}/${type}`,
      BULK_APPROVE: '/admin/news/bulk/approve',
      BULK_REJECT: '/admin/news/bulk/reject',
    },
    RSS: {
      BASE: '/admin/rss',
      DELETE: '/admin/rss/delete',
      EDIT: '/admin/rss/edit',
      SYNC_LATEST_NEWS: '/admin/rss/sync-latest-news',
    },
    TOPICS: {
      BASE: '/admin/topics',
      UPDATE: '/admin/topics/update',
    },
    HOT_TOPICS: {
      BASE: '/admin/hot-topics',
      CREATE: '/admin/hot-topics',
      UPDATE: (id: number) => `/admin/hot-topics/${id}`,
      DELETE: (id: number) => `/admin/hot-topics/${id}`,
    },
    FCM: {
      SEND_TO_TOPIC: '/api/firebase/sendNotificationToTopic',
      TRANSLATE_NOTIFICATION: '/api/firebase/translate-notification',
      SEND_LOCALIZED_NOTIFICATION: '/api/firebase/send-localized-notification',
      UPLOAD_IMAGE: '/upload/image',
      FREQUENCY_CONFIG: '/api/firebase/notification-frequency-config',
      RUN_LOCAL_AUTOMATION_NOW: '/api/firebase/notification-automation/run-local-now',
      RUN_NATIONAL_AUTOMATION_NOW: '/api/firebase/notification-automation/run-national-now',
    },
    IMAGE: {
      GENERATE_OVERLAY: '/image/generate-overlay',
      GENERATE_OVERLAY_FROM_URL: '/image/generate-overlay-from-url',
      GENERATE_QUOTE: '/image/generate-quote',
    },
  },
};
